import { Laptop, Smartphone } from "lucide-react";
import React from "react";

import type { WidgetDeviceType } from "@intelligems/ig-types";
import { IgTooltip } from "@intelligems/ig-theme";
import { ToggleButton } from "@mui/material";
import { ToggleButtonGroup } from "@src/features/experienceBuilder/toolbar/ToggleButtonGroup";
import { useDispatch, useSelector } from "@src/store";
import { ExperienceBuilderAiSelector } from "@src/store/slices/experienceBuilder/ai";
import {
  ExperienceBuilderAction,
  ExperienceBuilderSelector,
} from "@src/store/slices/experienceBuilder";

const tabs: { value: WidgetDeviceType; icon: React.ReactNode }[] = [
  { value: "mobile", icon: <Smartphone size={14} /> },
  { value: "desktop", icon: <Laptop size={14} /> },
];

export const DeviceSelector = () => {
  const dispatch = useDispatch();
  const device = useSelector(ExperienceBuilderSelector.getDevice);
  const isAiBusy = useSelector(ExperienceBuilderAiSelector.getIsAiBusy);

  const buttons = tabs.map((tab) => (
    <ToggleButton
      key={tab.value}
      value={tab.value}
      size="small"
      disabled={isAiBusy}
    >
      {tab.icon}
    </ToggleButton>
  ));

  return (
    <IgTooltip title={isAiBusy ? "AI is busy, please wait..." : ""}>
      <ToggleButtonGroup
        buttons={buttons}
        value={device}
        control={{
          exclusive: true,
          onChange: (_event, value) => {
            if (!value) {
              return;
            }
            dispatch(ExperienceBuilderAction.setDevice(value));
            void dispatch(
              ExperienceBuilderAction.trackModeToggled({ toggledTo: value })
            );
          },
        }}
      />
    </IgTooltip>
  );
};
